import { AxiosInstance } from 'axios';
import { IWebsitesApi, IResponse } from './types';
import { Website, IRawWebsite } from '../websites/types';

class WebsitesApi implements IWebsitesApi {
  constructor(
    private readonly axios: AxiosInstance,
    private readonly apiUrl: string = '/websites'
  ) {}

  create = async (model: IRawWebsite) => {
    const res: IResponse<Website> = { response: null, error: null };

    try {
      const response = await this.axios.post(`${this.apiUrl}/`, model);

      res.response = response.data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };

  update = async (model: Website) => {
    const res: IResponse<Website> = { response: null, error: null };

    try {
      const response = await this.axios.put(
        `${this.apiUrl}/${model.id}/`,
        model
      );

      res.response = response.data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };

  remove = async (id: string) => {
    const res: IResponse<boolean> = { response: null, error: null };

    try {
      const response = await this.axios.delete(`${this.apiUrl}/${id}/ `);

      res.response = response.data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };

  load = async () => {
    const res: IResponse<Website[]> = { response: null, error: null };

    try {
      const response = await this.axios.get(`${this.apiUrl}/`);

      res.response = response.data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };

  generateToken = async (id: string) => {
    const res: IResponse<{ token: string }> = { response: null, error: null };

    try {
      const response = await this.axios.post(`${this.apiUrl}/${id}/token/`);

      res.response = response.data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };
}

export default WebsitesApi;
